import React from 'react';
import classNameBind from 'classnames/bind';
import keyGetterGenerator from '../../utils/methods/keyGetterGenerator';
import styles from './ButtonGroup.module.css';

const bindClasses = classNameBind.bind(styles);

const getButtonKey = keyGetterGenerator('icon', 'text');

const ButtonGroup = ({
  className,
  segmented,
  getKey,
  children,
} = {}) => (
  <div
    className={`${bindClasses('buttonGroup', { segmented })} ${className}`}
    data-ppuc-id="ButtonGroup"
  >
    {React.Children.map(
      children,
      child => (
        <div
          className={bindClasses('item')}
          key={getKey(child)}
          data-ppuc-id="ButtonGroup.item"
        >
          {child}
        </div>
      ),
    )}
  </div>
);

ButtonGroup.defaultProps = {
  className: '',
  segmented: false,
  getKey: getButtonKey,
};

export default ButtonGroup;
